export class StringUtils {
  private static readonly WILD_CHAR = '%';

  public static parseBoolean(booleanValue: string, throwError = false): boolean | null {
    if (booleanValue != null) {
      switch (booleanValue.toLowerCase()) {
        case 'true':
          return true;
        case 'false':
          return false;
        default:
          if (throwError) {
            throw new Error(booleanValue + ' is not a valid string for boolean');
          }
      }
    }
    return null;
  }

  /** The native `encodeURIComponent` doesn't encode the characters: [!'()*], which is inconsistent with
   * the latest RFC3986. This function fixes this behaviour as suggested by:
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent#encoding_for_rfc3986
   * This is necessary as unencoded parentheses cause conflicts with Angular's named routes. For the discussion of this issue:
   * https://github.com/angular/angular/issues/10280 */
  public static updatedEncodeURIComponent(uriComponent: string): string {
    return encodeURIComponent(uriComponent).replace(/[!'()*]/g, (c) => '%' + c.charCodeAt(0).toString(16).toUpperCase());
  }

  /** Parses a whole number, dropping any fraction. Returns `null` rather than `NaN` when the value is not a number, so that a malformed
   * route or query param is treated as absent by the `!= null` check callers do, instead of reaching a request as `NaN`. */
  public static stringToNumber(value: string): number | null {
    const parsed = StringUtils.stringToDecimal(value);
    return parsed != null ? Math.trunc(parsed) : null;
  }

  /** Parses a whole or fractional number. Unlike `stringToNumber`, this keeps the fraction, so it suits a user entered value rather than
   * an id from a route or query param. Returns `null` unless the whole string is a finite number. */
  public static stringToDecimal(value: string): number | null {
    const trimmed = value?.trim();
    const parsed = trimmed?.length ? Number(trimmed) : NaN;
    return isFinite(parsed) ? parsed : null;
  }

  public static applyWildChars(str: string): string {
    return StringUtils.WILD_CHAR + (str ?? '') + StringUtils.WILD_CHAR;
  }

  public static asMissingId(str: string | number): string;
  public static asMissingId(str: string | number | null): string | null;
  public static asMissingId(str: string | number | null): string | null {
    if (str == null || str === '') {
      return <'' | null>str;
    }
    return '<' + str + '>';
  }

  public static isEmpty(str: string | null): boolean {
    return str == null || str === '';
  }
}
